import CheckIcon from '@heroicons/react/outline/esm/CheckIcon.js'

import { T } from '@tribeplatform/react-components/i18n'
import {
  useClearNotificationsCount,
  useReadNotifications,
} from '@tribeplatform/react-sdk/hooks'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

export const NotificationsMarkAsRead = () => {
  const { mutate: clearNotificationCount } = useClearNotificationsCount()
  const { mutate: readAllNotifications } = useReadNotifications()

  return (
    <button
      type="button"
      onClick={() => {
        readAllNotifications({ ids: [] })
        clearNotificationCount()
      }}
    >
      <Tooltip>
        <Tooltip.Trigger>
          <CheckIcon
            className="h-6 w-6 text-content-subdued hover:text-content-hovered"
            aria-hidden="true"
          />
        </Tooltip.Trigger>
        <Tooltip.Panel className="z-20">
          <T
            defaultMessage="Mark all as read"
            id="Notifications.MarkAllAsRead"
          />
        </Tooltip.Panel>
      </Tooltip>
    </button>
  )
}
